// taxtype = 1 => price without tax
// taxtype = 2 => price with tax
const productTaxTypes = {
  withTax: '2',
  withoutTax: '1'
};

export default productTaxTypes;
